import {
  loadCodeSet,
  loadCodeSetSuccess,
  loadCodeSetError,
} from './codeset.actions';

import { CodeSetResponse } from '../codeset/codeset.model';

import { ServiceError } from '@cigna/chcp/shared/util';
import { on, createReducer, Action } from '@ngrx/store';

export const CODESET_FEATURE_KEY = 'codesetFeature';

export interface CodesetState {
  codeSetResponse: CodeSetResponse | null;
  submitting: boolean;
  serviceError: ServiceError | null;
}

export const initialState: CodesetState = {
  codeSetResponse: null,
  submitting: false,
  serviceError: null,
};

export interface CodesetPartialState {
  readonly [CODESET_FEATURE_KEY]: CodesetState;
}

export const codesetReducer = createReducer(
  initialState,
  on(loadCodeSet, (state) => ({
    ...state,
    codeSetResponse: null,
    submitting: true,
    serviceError: null,
  })),
  on(loadCodeSetSuccess, (state, { payload }) => ({
    ...state,
    codeSetResponse: payload,
    submitting: false,
    serviceError: null,
  })),
  on(loadCodeSetError, (state, { error }) => ({
    ...state,
    codeSetResponse: null,
    submitting: false,
    serviceError: error,
  })),
);
export function reducer(state: CodesetState | undefined, action: Action) {
  return codesetReducer(state, action);
}
